import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUnionNode } from './TypedNode'
import { SchemaUnionModel } from './ViewModel'

export const SchemaUnionPlugin = createSchemaPlugin(
  'Schema.Union',
  SchemaUnionModel,
  SchemaUnionNode
)
